module.exports = __webpack_public_path__ + "static/media/bts_veld_170806_012_small.8918fa20.jpg";